module.exports = "/static/fonts/GretaSansH-L-Bold.3e2b0e0.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/GretaSansH-L-Bold.otf
// module id = VxSu
// module chunks = 6